import { useSelector } from 'react-redux';

import { selectRehydrated } from '@modules/persist/persist.selectors';

export const usePersist = () => {
  const isRehydrated = useSelector(selectRehydrated);

  return { isRehydrated };
};
